import React from "react";
import PropTypes from "prop-types";

import {
  CARRIER_PROFILE_DIALOGS_VM_SHAPE,
} from "./carrierProfileVmPropTypes";
import CarrierTeamMemberDialogs from "./dialogs/CarrierTeamMemberDialogs";
import CarrierStateBondDialogs from "./dialogs/CarrierStateBondDialogs";
import CarrierCompanyDialogs from "./dialogs/CarrierCompanyDialogs";
import CarrierLicenseInfoDialogs from "./dialogs/CarrierLicenseInfoDialogs";
import CarrierCommissionDialogs from "./dialogs/CarrierCommissionDialogs";
import CarrierLimitDialogs from "./dialogs/CarrierLimitDialogs";

export default function CarrierProfileDialogs({ vm }) {
  return (
    <>
      <CarrierTeamMemberDialogs vm={vm} />
      <CarrierStateBondDialogs vm={vm} />
      <CarrierCompanyDialogs vm={vm} />
      <CarrierLicenseInfoDialogs vm={vm} />
      <CarrierCommissionDialogs vm={vm} />
      <CarrierLimitDialogs vm={vm} />
    </>
  );
}

CarrierProfileDialogs.propTypes = {
  vm: PropTypes.shape(CARRIER_PROFILE_DIALOGS_VM_SHAPE).isRequired,
};
